import { trim } from "lodash-es";
import { FlightPrefillApiResult, FlightPrefillFields } from "Bands/types";

export const extractFlightNumberFromFlightPrefillFields = ({
  prefillFlightNumber,
  prefillFlightDate,
}: FlightPrefillFields): FlightPrefillApiResult => {
  // Remove all spaces from the string
  const trimmedFlightNumber = trim(prefillFlightNumber).replace(/\s/g, "");

  return {
    flightNumber: trimmedFlightNumber,
    departureDate: prefillFlightDate,
  };
};
